import { getMartech } from 'ctm-util-functions/lib/get';
import Immutable from 'immutable';

/**
 * Pulls out data from the quote state and builds a payload for GTM. Specific to home and contents.
 * @param {Immutable.Map} quote A Home and Contents Quote
 * @param {Immutable.Map} state Greater app state
 * @returns {Immutable.Map}     A Home and Contents Quote payload shaped correctly for consumption by marketing
 */
const getHomeContentsJourney = (quote, state) => {
    const getInQuote = getMartech(quote);
    const optInPrivacyPresented = state.getIn(['user', 'journey', 'applicantOptInPrivacyPresented']);

    return Immutable.Map({
        contact: {
            firstName: getInQuote('form.policyHolder.firstName'),
            lastName: getInQuote('form.policyHolder.lastName'),
            phone: getInQuote('form.contactDetails.mobile') || getInQuote('form.contactDetails.phone'),
            email: getInQuote('form.contactDetails.email'),
            optInPrivacy: getInQuote('form.contactDetails.optinPrivacy'),
            optInPrivacyPresented: optInPrivacyPresented === true
        },
        address: {
            gnafId: getInQuote('form.property.address.gnafId'),
            streetNumber: getInQuote('form.property.address.streetNumber'),
            streetName: getInQuote('form.property.address.streetName'),
            postcode: getInQuote('form.property.address.postcode'),
            suburb: getInQuote('form.property.address.suburb'),
            state: getInQuote('form.property.address.state')
        },
        data: {
            property: {
                propertyType: getInQuote('form.property.propertyType'),
                wallMaterial: getInQuote('form.property.wallMaterial'),
                roofMaterial: getInQuote('form.property.roofMaterial'),
                yearBuilt: getInQuote('form.property.yearBuilt'),
                hasBodyCorporate: getInQuote('form.property.hasBodyCorporate')
            },
            occupancy: {
                occupancyType: getInQuote('form.occupancy.occupancyType'),
                hasMortgage: getInQuote('form.occupancy.hasMortgage'),
                isPrincipalResidence: getInQuote('form.occupancy.isPrincipalResidence'),
                whenMovedIn: {
                    year: getInQuote('form.occupancy.whenMovedIn.year'),
                    month: getInQuote('form.occupancy.whenMovedIn.month')
                },
                isOldestResidentRetired: getInQuote('form.occupancy.isOldestResidentRetired')
            },
            cover: {
                coverType: getInQuote('form.coverDetails.coverType'),
                totalRebuildCost: getInQuote('form.coverDetails.totalRebuildCost'),
                totalContentReplacementCost: getInQuote('form.coverDetails.totalContentReplacementCost'),
                isAbovePolicyLimits: getInQuote('form.coverDetails.isAbovePolicyLimits'),
                portableItems: {
                    hasPortableItems: getInQuote('form.data.hasPortableItems'),
                    totalUnspecifiedPortableItems: getInQuote('form.coverDetails.portableItems.totalUnspecifiedPortableItems'),
                    specifyPortableItems: getInQuote('form.coverDetails.portableItems.specifyPortableItems'),
                    bicyclesCover: getInQuote('form.coverDetails.portableItems.bicyclesCover'),
                    musicalInstrumentsCover: getInQuote('form.coverDetails.portableItems.musicalInstrumentsCover'),
                    clothingCover: getInQuote('form.coverDetails.portableItems.clothingCover'),
                    jewelryWatchesCover: getInQuote('form.coverDetails.portableItems.jewelryWatchesCover'),
                    sportingEquipmentCover: getInQuote('form.coverDetails.portableItems.sportingEquipmentCover'),
                    photographicEquipmentCover: getInQuote('form.coverDetails.portableItems.photographicEquipmentCover')
                },
                businessActivity: {
                    hasBusinessActivity: getInQuote('form.data.hasBusinessActivity'),
                    businessType: getInQuote('form.businessActivity.businessType'),
                    numberOfBusinessRooms: getInQuote('form.businessActivity.numberOfBusinessRooms'),
                    hasEmployees: getInQuote('form.businessActivity.hasEmployees'),
                    numberOfOtherEmployees: getInQuote('form.businessActivity.numberOfOtherEmployees')
                },
                hasSecurityAlarm: getInQuote('form.data.hasSecurityAlarm'),
                commencementDate: getInQuote('form.coverDetails.commencementDate'),
                policyHolder: {
                    firstName: getInQuote('form.policyHolder.firstName'),
                    lastName: getInQuote('form.policyHolder.lastName'),
                    dob: getInQuote('form.policyHolder.dob')
                },
                excessDetails: {
                    contentsExcess: getInQuote('form.excessDetails.contentsExcess'),
                    homeExcess: getInQuote('form.excessDetails.homeExcess')
                },
                previousCover: {
                    hasPreviousClaims: getInQuote('form.previousCover.hasPreviousClaims')
                }
            },
            leadCapture: {
                health: getInQuote('form.leadCapture.health')
            },
            resultPageFilters: {
                displayMode: getInQuote('results.config.displayMode'),
                sortBy: getInQuote('results.config.sorting.sortBy'),
                frequency: getInQuote('results.config.filters.frequency'),
                available: getInQuote('results.config.filters.available'),
                initialised: getInQuote('results.config.filters.initialised'),
                contentsExcess: getInQuote('form.excessDetails.contentsExcess'),
                homeExcess: getInQuote('form.excessDetails.homeExcess'),
                fetchNewResults: getInQuote('results.config.filters.fetchNewResults'),
                currentFilterActions: getInQuote('results.config.filters.currentFilterActions'),
                features: getInQuote('form.config.features'),
                selectedProductIds: getInQuote('results.config.filters.selectedProductIds')
            }
        }
    });
};

export default getHomeContentsJourney;
